function openNav() {
  document.getElementById("mySidepanel").style.width = "80%";
}

function closeNav() {
  document.getElementById("mySidepanel").style.width = "0";
}

const listItems = document.querySelectorAll("li");

listItems.forEach((item) => {
  if (item.querySelector("ul")) {
    item.classList.add("has-submenu");
  }
});

// banner slider
$("#mob.owl-carousel").owlCarousel({
  loop: true,
  autoplay: true,
  autoplayTimeout: 4000,
  autoplayHoverPause: true,
  margin: 0,
  autoHeight: true,
  nav: false,
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
});
$("#desk.owl-carousel").owlCarousel({
  loop: true,
  autoplay: true,
  autoplayTimeout: 4000,
  autoplayHoverPause: true,
  margin: 0,
  autoHeight: true,
  nav: false,
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
});
// review slider
$(".reviewconts-part .owl-carousel").owlCarousel({
  loop: true,
  autoplay: false,
  autoplayTimeout: 2000,
  autoplayHoverPause: true,
  margin: 0,
  nav: true,
  dots: false,
  autoHeight: true,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 3,
    },
  },
});
